<template lang="pug">
.container.charges
  auto-edit-table(:defines='$defines.charge', :data='filtered', title='水电充值记录', :actions='[]', :buttonAdd='false', :pagesize='20', detail-view, summary)
    filters-group(:data='charges', :result.sync='filtered', slot='afterTitle')
      .ui.two.columns.stackable.form.grid.filters
        .column
          h4 充值时间
          filter-date-range(:filter='$defines.charge.filters.date', :select.sync='select')
        .column
          h4 搜索
          filter-search(:filter='$defines.charge.filters.search', :defines='$defines.charge', placeholder='搜索...')
</template>

<script>
import { AutoTable, AutoEditTable } from '../components/auto'
import { FiltersGroup, FilterSearch, FilterSelect, FilterDateRange } from '../components/filters'

export default {
  name: 'charges',
  components: { AutoTable, AutoEditTable, FiltersGroup, FilterSearch, FilterSelect, FilterDateRange },
  computed: {
    charges() {
      return this.$store.state.summary.charges
    },
  },
  data() {
    return {
      filtered: [],
      select: null,
    }
  },
  mounted() {
    this.$store.dispatch('load_charges')
    this.select = 'today'
  },
}
</script>



// WEBPACK FOOTER //
// Charges.vue?ab1f36a4